// 폴더 행 «⋯» 메뉴(position: fixed) 자리 — 단추 rect 기준(오른쪽 = 단추 오른쪽 · 아래 4px, 모자라면 위).
// 웹 배율(<html> zoom = s)이 걸리면 rect·innerWidth·innerHeight·documentElement.clientWidth 는 전부 화면 px,
// fixed top/right 는 CSS px 다 → 화면 폭·높이도 rect 와 같이 s 로 나눈다(할일 #2671: 폭만 안 나눠
// 1440 × (s − 1) = 130% 432 · 150% 720 화면 px 만큼 메뉴가 왼쪽으로 밀렸다).
export function folderMenuPos({ rect, s, panelH, innerWidth, innerHeight, docClientWidth }) {
  const vh = (innerHeight || 0) / s;
  const vw = (docClientWidth || innerWidth || 0) / s;
  const top = vh - rect.bottom / s < panelH ? Math.max(4, rect.top / s - 4 - panelH) : rect.bottom / s + 4;
  return { top: Math.round(top), right: Math.max(4, Math.round(vw - rect.right / s)) };
}
